import { FC } from 'react'
import { useDispatch } from 'react-redux';
import { setContactFilterType } from '../../../slices/contactAddressSlice';


export type RadioItem = {
  id: string
  value: string
  label: string
}

type Props = {
  state: any
  setState: React.Dispatch<React.SetStateAction<any>>
  name: string
  items: RadioItem[]
}

const RadioButton: FC<Props> = (props) => {
  const dispatch = useDispatch()
  const { state, setState, name, items } = props

  return (
    <span className="switcher:radio">
      {items.map((item, index) => (
        <span className="form-check" key={index}>
          <input
            className="form-check-input"
            type="radio"
            id={item.id}
            name={name}
            checked={state === item.value}
            onChange={() => {
              dispatch(setContactFilterType(item.value))
              setState(item.value)
            }}
          />
          <label className="form-check-label text-small" htmlFor={item.id}>
            {item.label}
          </label>
        </span>
      ))}
    </span>
  )
}

export default RadioButton
